import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: theme.spacing(1),
    border: "1px thin rgba(0, 0, 0, 0.4)",
    minWidth: "100%",
    "& .Mui-focused fieldset": {
      border: "none",
    },
    "& .MuiOutlinedInput-root": {
      boxShadow: "inset 1px 2px 2px rgba(0, 0, 0, 0.4)",
      height: theme.spacing(5),
      borderRadius: 0,
    },
    "& .MuiSvgIcon-root": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      marginTop: theme.spacing(-1),
      marginRight: "-6px",
      height: theme.spacing(5),
      width: "30px",
    },
    "& .MuiSelect-root": {
      padding: "10.5px 32px 10.5px 14px",
    },
  },
  label: {
    marginBottom: theme.spacing(1),
    color: "#000",
  },
  error: {
    color: "red",
  },
  dropDown: {
    textTransform: "uppercase",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: -5,
    "&:first-child": {
      marginLeft: 0,
    },
    marginLeft: 7,
  },
}));

export default useStyles;
